import { Component } from "@angular/core";

@Component({
  selector: "app-side-bar-right",
  templateUrl: "./side-bar-right.component.html",
  styleUrls: ["./side-bar-right.component.scss"],
})
export class SideBarRightComponent {}
